import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleOAuthCallback } = useAuth();
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    // Предотвращаем повторную обработку
    if (processed.current) return;
    processed.current = true;

    const processCallback = () => {
      const accessToken = searchParams.get('accessToken');
      const refreshToken = searchParams.get('refreshToken');
      const userRole = searchParams.get('userRole');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(decodeURIComponent(errorParam));
        setTimeout(() => {
          window.location.href = '/login?error=' + encodeURIComponent(errorParam);
        }, 2000);
        return;
      }

      if (!accessToken || !refreshToken) {
        setError(t('auth.oauth.errors.missingTokens'));
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      try {
        const result = handleOAuthCallback(accessToken, refreshToken, userRole);
        
        if (result.success) {
          // Используем window.location для надёжного редиректа
          window.location.href = '/dashboard';
        } else {
          setError(result.error || t('auth.oauth.errors.callbackFailed'));
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError(t('auth.oauth.errors.callbackFailed'));
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    };

    processCallback();
  }, []); // Пустой массив зависимостей - запускаем только один раз

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
          <div className="mb-4">
            <svg className="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('auth.oauth.errorTitle')}</h2>
          <p className="text-gray-600">{error}</p>
          <p className="text-sm text-gray-500 mt-4">{t('auth.oauth.redirecting')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
        <LoadingSpinner size="lg" className="mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('auth.oauth.processing')}</h2>
        <p className="text-gray-600">{t('auth.oauth.pleaseWait')}</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
